/**
 * De ingang: wie is ingelogd, en welk scherm hoort daarbij.
 *
 * Er is één inlogscherm en één gebruikerstabel; de rol bepaalt het scherm.
 * De browser bewaart de gebruiker en het token in localStorage, zodat een
 * herladen pagina niet opnieuw om inloggen vraagt. Verloopt het token (na
 * 24 uur), dan stuurt api/client.js hierheen terug: uitloggen.
 */
import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import BeheerPaneel from './pages/beheer/BeheerPaneel';
import LeerkrachtDashboard from './pages/leerkracht/LeerkrachtDashboard';
import LeerlingFlow from './pages/leerling/LeerlingFlow';
import { zetBijVerlopenToken } from './api/client';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null);
  };

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('token');
    if (storedUser && storedToken) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
    zetBijVerlopenToken(handleLogout);
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', token);
    setUser(userData);
  };

  if (loading) {
    return (
      <div className="flex-center" style={{ height: '100vh' }}>
        <p>Laden...</p>
      </div>
    );
  }

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  switch (user.role) {
    case 'admin':
      return <BeheerPaneel onLogout={handleLogout} />;
    case 'teacher':
      return <LeerkrachtDashboard user={user} onLogout={handleLogout} />;
    case 'student':
      return <LeerlingFlow user={user} onLogout={handleLogout} />;
    default:
      return <Login onLogin={handleLogin} />;
  }
}

export default App;
